export default `Arena
-=80
K=4
B=6
D=2
P=0
S=6
F=6

xxxxxxxxxxxxxxx
x1 --------- 2x
x x-x-x-x-x-x x
x-------------x
x-x-x-x-x-x-x-x
x-------------x
x-x-x-x-x-x-x-x
x-------------x
x-x-x-x-x-x-x-x
x-------------x
x x-x-x-x-x-x x
x3 --------- 4x
xxxxxxxxxxxxxxx`
